/**
 * Native shell detection (Capacitor). Web build stays unchanged; same code runs in
 * App Store / Play Store wrappers after `npm run cap:add:ios` or `cap:add:android`.
 */
import { Capacitor } from '@capacitor/core';

export function isNativeApp() {
  return Capacitor.isNativePlatform();
}

export function getNativePlatform() {
  return Capacitor.getPlatform();
}

export function isIOSNative() {
  return Capacitor.getPlatform() === 'ios';
}

export function isAndroidNative() {
  return Capacitor.getPlatform() === 'android';
}

/** Apply document classes for safe-area / native-only CSS hooks. */
export function applyNativeDocumentClasses() {
  if (typeof document === 'undefined' || !isNativeApp()) return;
  document.documentElement.classList.add('capacitor-native');
  document.body.classList.add(`capacitor-${getNativePlatform()}`);
}
